import { render, staticRenderFns } from "./chatroom_modal.vue?vue&type=template&id=496ab840&scoped=true&"
import script from "./chatroom_modal.vue?vue&type=script&lang=js&"
export * from "./chatroom_modal.vue?vue&type=script&lang=js&"
import style0 from "./chatroom_modal.vue?vue&type=style&index=0&id=496ab840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496ab840",
  null
  
)

export default component.exports